import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./tags-list-item.types";
import { AccordionItemContent } from "@edgetier/client-components";
import { Link, useLocation } from "react-router-dom";
import urlJoin from "url-join";
import { trackUser } from "utilities/track-user";
import TagActionsMenu from "components-for/tags/tag-actions-menu";
import { SidebarContext } from "@edgetier/sidebar";
import usePermission from "hooks-for/permissions/use-permission";
import TagsListContext from "../tags-list-context/tags-list-context";
import classNames from "classnames";
import "./tags-list-item.scss";

/**
 * Display a tag in an accordion item.
 * @param props.tag   The name of the tag being displayed.
 * @param props.tagId The ID of the tag being displayed.
 */
const TagsListItem: FunctionComponent<IProps> = ({ tag, tagId }) => {
    const { hideSidebar } = useContext(SidebarContext);
    const { actionPermissions, redirectRoute } = useContext(TagsListContext);
    const { hasPermission: canManagePhraseTriggers } = usePermission(actionPermissions);
    const location = useLocation();

    return (
        <AccordionItemContent>
            <div
                className={classNames("tags-list-item", {
                    "tags-list-item--active": location.pathname.includes(tagId),
                })}
            >
                {canManagePhraseTriggers ? (
                    <Link
                        onClick={() => {
                            hideSidebar();
                            trackUser("Select tag", { tagId });
                        }}
                        to={urlJoin(redirectRoute, tagId)}
                    >
                        <div className="tags-list-item__header">{tag}</div>
                    </Link>
                ) : (
                    <div className="tags-list-item__header">{tag}</div>
                )}

                <div className="tags-list-item__actions-menu">
                    <TagActionsMenu tag={tag} tagId={tagId} />
                </div>
            </div>
        </AccordionItemContent>
    );
};

export default memo(TagsListItem);
